module.exports = __webpack_public_path__ + "static/media/MANA-201-badge.eabccef0.svg";